import umlSelectionEngine from '../Core/UmlSelectionEngine';

class UmlDiagramItem {
    constructor(id, x, y) {
        this.id = id;
        this.x = x;
        this.y = y;
    }

    moveTo(x, y) {
        this.x = x;
        this.y = y;
    }

    select() {
        umlSelectionEngine.select(this.id);
    }
}

export default UmlDiagramItem;
